import { Box } from '@mui/material';
import { Heading } from './components/Heading';
import List from './components/List';
import { HowToEarnSection } from './components/HowToEarnSection';
import { appContainer } from '../../constants/styles';

export function PointsPage() {
  return (
    <Box sx={appContainer}>
      <Box
        sx={{
          display: 'flex',
          gap: 3,
          alignItems: 'flex-start',
          flexDirection: { xs: 'column', md: 'row' },
        }}
      >
        {/* Left column: hero + level + history */}
        <Box sx={{ flex: 1, minWidth: 0, width: '100%' }}>
          <Heading />
          <List />
        </Box>

        {/* Right column: how to earn points */}
        <Box sx={{ width: { xs: '100%', md: '300px' }, flexShrink: 0 }}>
          <HowToEarnSection />
        </Box>
      </Box>
    </Box>
  );
}

export default PointsPage;
